export const BRAND = {
  name: "E L Lawn Services Inc",
  shortName: "E L Lawn Services",
  owner: "Enrique Lopez",
  phone: "561-345-9299",
  phoneTel: "+15613459299",
  email: "Enriquelopez1212@gmail.com",
  experienceYears: 20,
  serviceAreas: [
    "Jupiter",
    "Jupiter Farms",
    "Tequesta",
    "Hobe Sound",
    "Stuart",
    "Palm Beach Gardens",
    "West Palm Beach",
  ],
  social: {
    facebook: "#",
    instagram: "#",
  },
  address: "306 4th St, Jupiter, FL 33458, USA",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_b886cc75-bc3b-4901-a0fa-cb8a9faa881a/artifacts/z83gaqf0_WhatsApp%20Image%202026-04-28%20at%2015.59.00.jpeg",
};

export const SERVICES = [
  {
    slug: "lawn-mowing-maintenance",
    title: "Lawn Mowing & Maintenance",
    short: "Crisp, even cuts on a schedule that keeps your yard pristine year-round.",
    description:
      "Weekly and bi-weekly mowing, edging, line-trimming, and blowoff. Our crews keep your lawn looking sharp with consistent height, clean edges, and tidy walkways every visit.",
    icon: "Sprout",
    image: "https://images.unsplash.com/photo-1596552254354-3ba557926c98?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "hedge-shrub-trimming",
    title: "Hedge & Shrub Trimming",
    short: "Defined shapes and healthy growth for hedges, ornamentals, and shrubs.",
    description:
      "Precision trimming and shaping for all hedge varieties. We promote dense, healthy growth and keep your property's profile clean and intentional.",
    icon: "Scissors",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/eoo52qz0_EL%20Lawn_hedge%20.jpeg",
  },
  {
    slug: "tree-trimming",
    title: "Tree Trimming",
    short: "Safe pruning and palm cleanups for South Florida trees.",
    description:
      "Selective pruning, deadwood removal, and palm tree cleanups. Improve canopy health, light penetration, and storm safety for properties of any size.",
    icon: "TreePalm",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/zyomuwvj_EL%20Lawn_tree%20trimmer.jpeg",
  },
  {
    slug: "mulching",
    title: "Mulching",
    short: "Fresh mulch installation that protects soil and elevates curb appeal.",
    description:
      "Premium mulch delivery and installation around beds, trees, and palms. Locks in moisture, suppresses weeds, and gives your landscape a finished look.",
    icon: "Layers",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/51c8kzvx_EL%20Lawn_mulching.jpeg",
  },
  {
    slug: "weed-control",
    title: "Weed Control",
    short: "Proactive treatments that keep beds and lawns weed-free.",
    description:
      "Targeted pre-emergent and post-emergent treatments. We focus on long-term suppression so your lawn and beds stay clean between services.",
    icon: "ShieldCheck",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/0dcawj53_EL%20Lawn_weed%20control.jpeg",
  },
  {
    slug: "fertilization",
    title: "Fertilization",
    short: "Custom feeding programs for thick, deep-green Florida turf.",
    description:
      "Seasonal fertilization tuned to your turf type and soil. We help build root strength, color, and resilience against South Florida heat and rain.",
    icon: "FlaskConical",
    image: "https://images.unsplash.com/photo-1722480419968-a8785b569190?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "sod-installation",
    title: "Sod Installation",
    short: "Fresh sod laid right - from prep to perfect, healthy lawn.",
    description:
      "Site prep, grading, and professional sod installation in St. Augustine, Zoysia, and other Florida-friendly varieties. Beautiful new lawn, fast.",
    icon: "Grid3x3",
    image: "https://images.unsplash.com/photo-1558904541-efa843a96f01?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "landscape-design",
    title: "Landscape Design",
    short: "Thoughtful, tropical landscapes that fit your home and lifestyle.",
    description:
      "Full landscape design and installation - from tropical plantings to modern beds. We combine form, function, and Florida-tough plants for lasting beauty.",
    icon: "Compass",
    image: "https://images.unsplash.com/photo-1558293842-c0fd3db86157?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "irrigation",
    title: "Irrigation",
    short: "Efficient sprinkler systems, repairs, and water-smart tuning.",
    description:
      "Sprinkler repairs, head replacements, controller tuning, and zone audits. Keep your landscape healthy while saving water and lowering bills.",
    icon: "Droplets",
    image: "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?auto=format&fit=crop&w=800&q=80",
  },
  {
    slug: "landscape-lighting",
    title: "Landscape Lighting",
    short: "Beautiful, low-voltage lighting that brings your property to life at night.",
    description:
      "Pathway, accent, and architectural lighting design and installation. We highlight the best features of your landscape and improve safety after dark.",
    icon: "Lightbulb",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/5tvphi6u_EL%20Lawn_landscape%20lighting.jpeg",
  },
  {
    slug: "rock-installation",
    title: "Rock Installation",
    short: "Decorative rock and pebble installs that elevate any bed or border.",
    description:
      "River rock, pebbles, and decorative stone installations around palms, beds, and walkways. Low-maintenance beauty with crisp, modern lines.",
    icon: "Mountain",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/2opb5i35_EL%20Lawn_rock%20installation.jpeg",
  },
  {
    slug: "pressure-washing",
    title: "Pressure Washing",
    short: "Restore driveways, pavers, and patios to like-new condition.",
    description:
      "Professional pressure washing for driveways, pavers, walkways, and pool decks. Removes mold, mildew, and stains - instantly boosting curb appeal.",
    icon: "Droplet",
    image: "https://customer-assets.emergentagent.com/job_el-lawn-services/artifacts/hssm50iq_EL%20Law_pressure%20washing.jpeg",
  },
];

export const TESTIMONIALS = [
  {
    name: "Linda M.",
    location: "Jupiter, FL",
    quote:
      "Enrique and his crew have taken care of our property for years. The yard always looks immaculate, and they show up like clockwork.",
    rating: 5,
  },
  {
    name: "David R.",
    location: "Palm Beach Gardens, FL",
    quote:
      "Honest, reliable, and seriously skilled. They redid our whole front bed and the curb appeal is night and day.",
    rating: 5,
  },
  {
    name: "Megan T.",
    location: "Stuart, FL",
    quote:
      "We've tried a lot of lawn companies in the area. E L Lawn Services is the only one that gets every detail right - edges, shrubs, blow-off, all of it.",
    rating: 5,
  },
];
